import { render, staticRenderFns } from "./Modelo1Component.vue?vue&type=template&id=7b6378d0"
import script from "./Modelo1Component.vue?vue&type=script&lang=js"
export * from "./Modelo1Component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports